import React from 'react'
import {Avatar, Comment} from 'antd';
import MarkdownTimeline from "./MarkdownTimeline";
import {FeatherIcon} from "@web/assets/icons";
import PropTypes from "prop-types";
import {chatAppAgentIds} from "@oven/app-thescribe/src/dashboard.config";

ChatResponseStream.propTypes = {
  stream: PropTypes.object,
}

export default function ChatResponseStream(props) {
  return <div className="brainstorm-message left chat-feedback-view">
    {props.stream?.answers?.length &&
      <section className="space space-end-y">
        <div className="space space-col">
          <Comment
            avatar={
              <Avatar
                icon={<FeatherIcon className="gold-icon" style={{position: "relative", top: 4}} />}
                size="large"
                className="transparent-bg"
              />
            }
            content={
              props.stream.answers.map((answer) =>
                !!answer.text &&
                !!answer.toolCalls &&
                !chatAppAgentIds.includes(answer.agentId) &&
                <MarkdownTimeline
                  key={answer.generated}
                  markdown={answer.text}
                />)
            }
          />
        </div>
      </section>}
  </div>
}
